// Automatisch gegenereerd bij build (scripts/genbuildinfo.js). Niet handmatig aanpassen.
export const BUILD_DATUM = '26.07.27';
export const BUILD_TIJD = '1304';
